import { useStore } from "@/stores/RootStoreContext"
import { MenuAdmin } from "@/components/admin/MenuAdmin"
import { Header } from "@/components/common/header/Header"
import * as TrinityAPI from "@/requests/TrinityAPI"
import { ModalPopUp } from "@/components/common/element/ModalPopUp"

import { MenuManager } from "../MenuManager"

import { BalanceTotal } from "./components/Total"
import { BalancePickCompany } from "./components/PickCompany"
import { BalanceBanks } from "./components/Banks"
import { BalanceHistory } from "./components/History"

import { useEffect, useState, type FC } from "react"
import type { IFullCompanyDto } from "@/types/company/IFullCompanyDto"
import type { IModalMessage } from "@/types/error/IModalMessage"

import style from "./style.module.scss"
import { useSearchParams } from "react-router-dom"

export const ManagerBalance: FC = () => {
  const { userStore } = useStore()

  const [searchParams] = useSearchParams()

  const [message, setMessage] = useState<IModalMessage | null>(null)
  const [companies, setCompanies] = useState<IFullCompanyDto[]>([])
  const [company, setCompany] = useState<IFullCompanyDto | null>(null)
  const [companyRef, setCompanyRef] = useState<IFullCompanyDto | null>(null)
  const [balances, setBalances] = useState<Record<string, number>>()
  const [isLoading, setLoading] = useState(true)

  const changeCompany = (value: string) => {
    const companyFromList = companies.find(el => Number(el.id) === Number(value))

    setCompany(companyFromList || null)
  }

  useEffect(() => {
    TrinityAPI.getCompanyList(response => {
      if (response.status === 200) {
        setCompanies(response.data)
      } else {
        setMessage({ title: "Ошибка!", text: `Ошибка загрузки списка компаний: ${response.data}` })
      }
    })
  }, [])

  useEffect(() => {
    if (company?.id) {
      TrinityAPI.getCompanyBalance(String(company.id), response => {
        if (response.status === 200) {
          setCompanyRef(response.data.company)
          setBalances(response.data.balance)
        } else {
          setMessage({ title: "Ошибка!", text: `Ошибка загрузки баланса компании: ${response.data}` })
        }
      })
    }
  }, [company?.id])

  useEffect(() => {
    if (companies.length && !company?.id) {
      const firstSelectedCompany = searchParams.has("companyId")
        ? companies.find(el => Number(el.id) === Number(searchParams.get("companyId")))
        : null

      setCompany(firstSelectedCompany ?? companies[0])
    }
  }, [companies, company])

  useEffect(() => {
    if (companyRef && isLoading) {
      setLoading(false)
    }
  }, [companyRef, isLoading])

  return (
    <>
      <ModalPopUp message={message} close={() => setMessage(null)} />
      {userStore.isManager ? <MenuManager active="balance" /> : <MenuAdmin active="balance" />}
      <main className="main-container" id="scrollable">
        <Header />
        <div className="container">
          <div className={style.mainContainer}>
            <h1 className="ui-heading">Балансы</h1>

            <BalancePickCompany
              companies={companies}
              changeCompany={changeCompany}
              company={company}
              isLoading={isLoading}
            />
            <BalanceTotal balances={balances} />
            <BalanceBanks isLoading={isLoading} banks={companyRef?.banksRef || []} />
            {companyRef?.id && company?.id && (
              <BalanceHistory companyId={company.id} banks={companyRef?.banksRef || []} setMessage={setMessage} />
            )}
          </div>
        </div>
      </main>
    </>
  )
}
